import React from "react";
import SEO from "@/components/SEO";

export default function Legal({ kind = "privacy" }) {
  const isPrivacy = kind === "privacy";
  return (
    <>
      <SEO title={isPrivacy ? "Privacybeleid" : "Voorwaarden"} path={isPrivacy ? "/privacy" : "/terms"} />
      <section className="container-x section-y max-w-3xl">
        <h1 className="font-heading text-4xl font-black tracking-tight">{isPrivacy ? "Privacybeleid" : "Algemene voorwaarden"}</h1>
        <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800">
          Dit is voorlopige juridische tekst in afwachting van beoordeling door VoiceOverKids. De definitieve tekst vereist juridische controle vóór livegang.
        </div>
        <div className="prose mt-8 space-y-4 text-zinc-600">
          {isPrivacy ? (
            <>
              <p>VoiceOverKids.Agency (De Savornin Lohmanplein 2, 2314 EV Leiden, Nederland) respecteert je privacy en beschermt de persoonsgegevens van klanten en jonge performers.</p>
              <p><strong>Privacy van kinderen:</strong> We publiceren nooit privé-achternamen, geboortedata, adressen, scholen of contactgegevens van verzorgers van jonge performers. Alleen bewust gepubliceerde openbare informatie wordt getoond.</p>
              <p><strong>Gegevens die we verzamelen:</strong> De contact- en castingaanvraaggegevens die je verstuurt, worden opgeslagen om op je verzoek te reageren. We laden geen niet-essentiële tracking zonder toestemming waar dat vereist is.</p>
              <p><strong>Jouw rechten:</strong> Je kunt inzage, correctie of verwijdering van je persoonsgegevens aanvragen door te mailen naar bookings@voiceoverkids.agency.</p>
            </>
          ) : (
            <>
              <p>Gebruik van AI-stemmen en menselijke opnames is onderworpen aan een licentie voor het overeengekomen gebruik en territorium. Commercieel/uitzendgebruik vereist de passende buy-out.</p>
              <p>Voor commerciële AI-licenties neem contact op via licensing@voiceoverkids.agency.</p>
              <p>Alle boekingen zijn onder voorbehoud van beschikbaarheid van het kind, arbeidsregels en toestemming van de verzorger.</p>
            </>
          )}
        </div>
      </section>
    </>
  );
}
